import React from 'react'
import styled from 'styled-components'
import LazyImage from '../../../components/LazyImage'
import { motion } from 'framer-motion'
import { useCongress } from '../../../congress/hooks'
import { childVariants } from '../../../framerOptions'

export default function OrganizerCard ({ imageURL, name, position, id }) {
  const { congress, generateLink } = useCongress()

  return (
   <Container variants={childVariants}>
     <Image src={imageURL} width="10rem" height="10rem"/>
     <Name color={congress.PrimaryColor}>{name}</Name>
     <Position>{position}</Position>
   </Container>
  )
}

const Container = styled(motion.div)`
  background: #FFF;
  box-shadow: 0 3px 20px rgba(197, 217, 232, 0.5);
  border-radius: 12px;
  width: 100%;
  margin: 1.2rem 0;
  display: flex;
  padding: 2rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const Image = styled(LazyImage)`
  border-radius: 50px;
  overflow: hidden;
`

const Name = styled.p`
  font-size: 1.5rem;
  font-weight: 800;
  margin-top: 1rem;
  color: ${props => props.color}
`

const Position = styled.p`
  font-size: 1.4rem;
  font-weight: 300;
  color: #707E83;
  margin: 0;
`